var array = Array.prototype;

export var map = array.map;
export var slice = array.slice;



//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/d3-scale/src/array.js
// module id = ../../../../d3-scale/src/array.js
// module chunks = vendor